
export const isOfType = <T  extends string>(value: string, arrays: string[]): value is T => {
  return arrays.includes(value);
}